import { PageableDTO } from "../../../types/pageable";
import { URL } from "../../../libraries/http/url";
import { Predicates } from "../../../libraries/predicates/predicates";
import { AxiosInstance } from "axios";
import { MasterArtworkCollectionState } from "../../../states/meta-artwork/collections/data.type";

type SearchParams = {
  search?: string;
  id?:string | number;
};

type PrintingTechniqueResponse =
  | PageableDTO<MasterArtworkCollectionState[]>
  | MasterArtworkCollectionState[];

export const fetchPrintingTechnique = async ({
  search,
  id,
  axios,
}: SearchParams & { axios: AxiosInstance }) => {
  try {
    const searchParams = URL.createSearchParams({
      id,
      search,
      limit: 50,
    });

    const url = !!id ? `/artwork/printing-technique/${id}`: `/artwork/printing-technique/?${searchParams.toString()}`

    const response = await axios.get<PrintingTechniqueResponse>(
      url
    );

    return Predicates.parsePageableReponseToType(response);
  } catch (err) {
    console.error(err);
  }
  return [];
};
